import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const LockBigIcon = ({ width = 101, height = 132 }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 101 132">
      {/*opacity="0.6"*/}
      <path
        d="M91.4501 55.9452H77.9881V39.8347C77.9881 25.6346 66.4361 14.0799 52.2391 14.0799C38.0421 14.0799 26.4901 25.6346 26.4901 39.8347V55.951H13.0282V39.8347C13.0282 18.2074 30.6167 0.61499 52.2391 0.61499C73.8616 0.61499 91.4501 18.2074 91.4501 39.8347V55.9452Z"
        fill="currentColor"
      />
      <path
        d="M86.0443 55.336H72.5823V39.2197C72.5823 25.0196 61.0303 13.465 46.8333 13.465C32.6364 13.465 21.0843 25.0196 21.0843 39.2197V55.336H7.62238V39.2197C7.62238 17.5924 25.2109 0 46.8333 0C68.4558 0 86.0443 17.5924 86.0443 39.2197V55.336Z"
        fill="currentColor"
      />
      <path
        d="M56.6208 131.003C32.1103 131.003 12.2357 111.13 12.2357 86.6083V59.7305C12.2357 57.1834 14.2961 55.1226 16.8426 55.1226H96.3931C98.9397 55.1226 101 57.1834 101 59.7305V86.6083C101.006 111.13 81.1312 131.003 56.6208 131.003Z"
        fill="currentColor"
      />
      <path
        d="M44.3851 131.003C19.8746 131.003 0 111.13 0 86.6083V59.7305C0 57.1834 2.06038 55.1226 4.60693 55.1226H84.1575C86.704 55.1226 88.7644 57.1834 88.7644 59.7305V86.6083C88.7702 111.13 68.8956 131.003 44.3851 131.003Z"
        fill="currentColor"
      />
      <path
        opacity="0.85"
        d="M58.235 82.8989C58.235 77.6136 53.9522 73.3298 48.6681 73.3298C43.384 73.3298 39.1012 77.6136 39.1012 82.8989C39.1012 86.5053 41.1153 89.6024 44.0612 91.2348V102.436C44.0612 104.983 46.1216 107.044 48.6681 107.044C51.2089 107.044 53.275 104.983 53.275 102.436V91.2406C56.2151 89.6082 58.235 86.5053 58.235 82.8989Z"
        fill="currentColor"
      />
      <path
        opacity="0.85"
        d="M53.9517 82.8989C53.9517 77.6136 49.6689 73.3298 44.3848 73.3298C39.1007 73.3298 34.8179 77.6136 34.8179 82.8989C34.8179 86.5053 36.832 89.6024 39.7779 91.2348V102.436C39.7779 104.983 41.8382 107.044 44.3848 107.044C46.9255 107.044 48.9917 104.983 48.9917 102.436V91.2406C51.9318 89.6082 53.9517 86.5053 53.9517 82.8989Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LockBigIcon;
